import angular from 'angular'
import React from 'react'
import 'react-dom'
import { emitter } from '../../../util.js'

angular.module('pub.bundle.step2.react', []).factory('TableStep2', TableStep2)

function TableStep2(
  $stateParams,
  $q,
  CollectiblesService,
  OddsService,
  ChannelsService,
  BundleCache,
  API,
  UserCache,
) {
  return React.createClass({
    displayName: 'TableStep2',
    propTypes: {
      s3: React.PropTypes.string,
      productType: React.PropTypes.array,
      edition: React.PropTypes.array,
      setType: React.PropTypes.array,
    },
    getDefaultProps: function () {
      return { s3: '' }
    },
    getInitialState: function () {
      return {
        data: [],
        odds: [],
        checkStep2: false,
        s3: '',
      }
    },
    componentDidMount: function () {
      var collectibles = []
      var odds = []

      console.log(this.props)

      var promises = {
        odds: OddsService.get($stateParams.id),
      }

      if ($stateParams.channelId) {
        promises.collectibles = CollectiblesService.getChannelId($stateParams.channelId)
      } else {
        promises.collectibles = CollectiblesService.getSetId($stateParams.parentId)
      }

      $q.all(promises).then(success.bind(this))

      function oddsRecursive(data) {
        var count = 0
        for (var i = 0; i < data.length; i++) {
          if (data[i].g !== undefined) {
            if (data[i].g === false) {
              count += data[i].o
            }
          } else {
            count += data[i].o
          }
        }
        return count
      }

      function success(results) {
        var collectibles1 = _.filter(angular.copy(results.collectibles.results), { st: 1 })
        var collectibles2 = _.filter(angular.copy(results.collectibles.results), { st: 4 })
        for (var i = 0; i < collectibles1.length; i++) {
          collectibles.push(collectibles1[i])
        }
        for (var i = 0; i < collectibles2.length; i++) {
          collectibles.push(collectibles2[i])
        }
        var collectiblesSoldOut = _.filter(results.collectibles.results, { st: 2 })
        for (var x = 0; x < collectiblesSoldOut.length; x++) {
          collectiblesSoldOut[x].tog = false
          collectibles.push(collectiblesSoldOut[x])
        }
        odds = results.odds.results
        var allCollectiblesStep2Checked = 0
        var allCollectibleProgressFour = 0

        var lenCollectible = collectibles.length
        var lenOdd = odds.length
        for (var i = 0; i < lenCollectible; i++) {
          collectibles[i].progress = 0
          collectibles[i].printCount = 0
          if (collectibles[i].t !== '') {
            collectibles[i].progress += 1
          }
          if (collectibles[i].e !== 0) {
            collectibles[i].progress += 1
          }
          if (collectibles[i].bc !== 0) {
            collectibles[i].progress += 1
          }
          if (collectibles[i]['img-t'] !== '') {
            collectibles[i].progress += 1
          }

          if (collectibles[i].st === 0) {
            collectibles[i].status = 'Draft'
          } else if (collectibles[i].st === 1) {
            collectibles[i].status = 'Published'
          } else if (collectibles[i].st === 2) {
            collectibles[i].status = 'Sold Out'
          } else if (collectibles[i].st === 3) {
            collectibles[i].status = 'Unavailable'
          } else if (collectibles[i].st === 4) {
            collectibles[i].status = 'Awaiting Count'
          }

          collectibles[i].printCount = collectibles[i].bc * window.Math.pow(collectibles[i].em, collectibles[i].e - 1)
          if (isNaN(collectibles[i].printCount)) {
            collectibles[i].printCount = 0
          }

          if (odds.length === 0) {
            collectibles[i].tog = false
          }

          for (var j = 0; j < lenOdd; j++) {
            odds[j].oddsPer = 0
            odds[j].oddsPer = oddsRecursive(odds)
            if (odds[j].g) {
              odds[j].o = 1000
            }

            if (collectibles[i].id === odds[j]['id-q']) {
              odds[j].t = collectibles[i].t
              odds[j]['img-t'] = collectibles[i]['img-t']
              odds[j].cr = collectibles[i].cr
            }

            if (collectibles[i].id === odds[j]['id-q']) {
              collectibles[i].tog = true
            }

            if (collectibles[i].tog === undefined) {
              collectibles[i].tog = false
            }
          }

          if (collectibles[i].tog === true && collectibles[i].progress === 4) {
            allCollectiblesStep2Checked += 1
          }
          if (collectibles[i].progress === 4) {
            allCollectibleProgressFour += 1
          }
        }

        if (allCollectiblesStep2Checked === allCollectibleProgressFour) {
          this.setState({
            checkStep2: true,
          })
        } else {
          this.setState({
            checkStep2: false,
          })
        }

        collectibles = _.orderBy(collectibles, 'n')
        this.setState({
          data: collectibles,
          odds: odds,
        })
      }

      emitter.on('updateData', (data) => {
        this.reload(data)
      })

      emitter.on('removeSoldOut', () => {
        this.removeSoldOut()
      })
    },
    componentWillUnmount: function () {
      emitter.off('updateData', this.reload)
      emitter.off('removeSoldOut')
    },
    reload: function (data) {
      var collectibles = []
      var odds = []

      var promises = {
        odds: OddsService.get($stateParams.id),
      }

      if ($stateParams.channelId) {
        promises.collectibles = CollectiblesService.getChannelId($stateParams.channelId)
      } else {
        promises.collectibles = CollectiblesService.getSetId($stateParams.parentId)
      }

      $q.all(promises).then(success.bind(this))

      function oddsRecursive(data) {
        var count = 0
        for (var i = 0; i < data.length; i++) {
          if (data[i].g !== undefined) {
            if (data[i].g === false) {
              count += data[i].o
            }
          } else {
            count += data[i].o
          }
        }
        return count
      }

      function success(results) {
        var collectibles1 = _.filter(angular.copy(results.collectibles.results), { st: 1 })
        var collectibles2 = _.filter(angular.copy(results.collectibles.results), { st: 4 })
        for (var i = 0; i < collectibles1.length; i++) {
          collectibles.push(collectibles1[i])
        }
        for (var i = 0; i < collectibles2.length; i++) {
          collectibles.push(collectibles2[i])
        }
        var collectiblesSoldOut = _.filter(results.collectibles.results, { st: 2 })
        for (var x = 0; x < collectiblesSoldOut.length; x++) {
          collectiblesSoldOut[x].tog = false
          collectibles.push(collectiblesSoldOut[x])
        }
        odds = results.odds.results
        var allCollectiblesStep2Checked = 0
        var allCollectibleProgressFour = 0

        var lenCollectible = collectibles.length
        var lenOdd = odds.length
        for (var i = 0; i < lenCollectible; i++) {
          collectibles[i].progress = 0
          collectibles[i].printCount = 0
          if (collectibles[i].t !== '') {
            collectibles[i].progress += 1
          }
          if (collectibles[i].e !== 0) {
            collectibles[i].progress += 1
          }
          if (collectibles[i].bc !== 0) {
            collectibles[i].progress += 1
          }
          if (collectibles[i]['img-t'] !== '') {
            collectibles[i].progress += 1
          }

          if (collectibles[i].st === 0) {
            collectibles[i].status = 'Draft'
          } else if (collectibles[i].st === 1) {
            collectibles[i].status = 'Published'
          } else if (collectibles[i].st === 2) {
            collectibles[i].status = 'Sold Out'
          } else if (collectibles[i].st === 3) {
            collectibles[i].status = 'Unavailable'
          } else if (collectibles[i].st === 4) {
            collectibles[i].status = 'Awaiting Count'
          }

          collectibles[i].printCount = collectibles[i].bc * window.Math.pow(collectibles[i].em, collectibles[i].e - 1)
          if (isNaN(collectibles[i].printCount)) {
            collectibles[i].printCount = 0
          }

          if (odds.length === 0) {
            collectibles[i].tog = false
          }

          for (var j = 0; j < lenOdd; j++) {
            odds[j].oddsPer = 0
            odds[j].oddsPer = oddsRecursive(odds)
            if (odds[j].g) {
              odds[j].o = 1000
            }

            if (collectibles[i].id === odds[j]['id-q']) {
              odds[j].t = collectibles[i].t
              odds[j]['img-t'] = collectibles[i]['img-t']
              odds[j].cr = collectibles[i].cr
            }

            if (collectibles[i].id === odds[j]['id-q']) {
              collectibles[i].tog = true
            }

            if (collectibles[i].tog === undefined) {
              collectibles[i].tog = false
            }
          }

          if (collectibles[i].tog === true && collectibles[i].progress === 4) {
            allCollectiblesStep2Checked += 1
          }
          if (collectibles[i].progress === 4) {
            allCollectibleProgressFour += 1
          }
        }

        if (allCollectiblesStep2Checked === allCollectibleProgressFour) {
          this.setState({
            checkStep2: true,
          })
        } else {
          this.setState({
            checkStep2: false,
          })
        }

        collectibles = _.orderBy(collectibles, 'n')
        if (data) {
          if (data.productType && data.productType?.length > 0) {
            // I have collectibles an array of objects and I want to filter it by the productType that is array of numbers
            collectibles = _.filter(collectibles, (collectible) => data.productType.includes(collectible['k-prod']))
          }
          if (data.edition && data.edition?.length > 0) {
            collectibles = _.filter(collectibles, (collectible) => data.edition.includes(collectible['e']))
          }
          if (data.setType && data.setType?.length > 0) {
            collectibles = _.filter(collectibles, (collectible) => data.setType.includes(collectible?.s['k']))
          }
        }
        this.setState({
          data: collectibles,
          odds: odds,
        })
      }
    },
    toogleAll: function (event) {
      this.state.checkStep2 = !this.state.checkStep2
      var checkStep2 = this.state.checkStep2
      var models = []
      var promise = []
      var isEnter = false
      if (checkStep2) {
        var isTog = true
        var len = this.state.data.length
        for (var i = 0; i < len; i++) {
          //  && this.props.data[i].progress === 4
          if (this.state.data[i].tog === !isTog) {
            this.state.data[i].tog = isTog
            this.state.data[i]['id-b'] = parseInt($stateParams.id)
            if (isTog) {
              var model = {
                'id-b': parseInt($stateParams.id),
                o: 1000,
                'id-q': this.state.data[i].id,
                g: false,
              }
              if (this.state.data[i].st !== 2) {
                models.push(model)
              }
            } else {
              if (this.state.data[i].st === 0) {
                for (var j = 0; j < this.state.odds.length; j++) {
                  if (this.state.odds[j]['id-q'] === this.state.data[i].id) {
                    isEnter = true
                    promise.push(OddsService.deleteOdd(this.state.odds[j].id))
                    break
                  }
                }
              } else {
                this.state.data[i].tog = true
              }
            }
          }
        }
      } else {
        var isTog = false
        var len = this.state.data.length
        for (var i = 0; i < len; i++) {
          //  && this.props.data[i].progress === 4
          if (this.state.data[i].tog === !isTog) {
            this.state.data[i].tog = isTog
            this.state.data[i]['id-b'] = parseInt($stateParams.id)
            if (isTog) {
              var model = {
                'id-b': parseInt($stateParams.id),
                o: 1000,
                'id-q': this.state.data[i].id,
                g: false,
              }
              if (this.state.data[i].st !== 2) {
                models.push(model)
              }
            } else {
              // if (this.state.data[i].st === 0) {
              for (var j = 0; j < this.state.odds.length; j++) {
                if (this.state.odds[j]['id-q'] === this.state.data[i].id) {
                  isEnter = true
                  promise.push(OddsService.deleteOdd(this.state.odds[j].id))
                  break
                }
              }
              // }
              // else {
              //   this.state.data[i].tog = true;
              // }
            }
          }
        }
      }

      if (!isEnter) {
        this.setState({
          checkStep2: true,
        })
      }

      if (checkStep2) {
        OddsService.save(parseInt($stateParams.id), models).then(success.bind(this))

        function success(result) {
          var odds = []
          if (this.state.odds.length > 0) {
            odds = this.state.odds
          }

          for (var i = 0; i < result.results.length; i++) {
            odds.push(result.results[i])
          }

          toastr.success('Saved!')
          this.setState({
            data: this.state.data,
            odds: odds,
            checkStep2: checkStep2,
          })
        }
      } else {
        $q.all(promise).then(success.bind(this))

        function success() {
          toastr.success('Saved!')
          var odds = []
          if (this.state.odds.length > 0) {
            odds = this.state.odds
          }

          this.setState({
            data: this.state.data,
            odds: odds,
            checkStep2: checkStep2,
          })
        }
      }
    },
    toogleChange: function (index) {
      this.state.data[index].tog = !this.state.data[index].tog
      var item = this.state.data[index]
      this.setState({
        data: this.state.data,
        odds: this.state.odds,
      })
      item.tog === true ? this.add(item) : this.remove(item, index)
    },
    add: function (item) {
      var model = {
        'id-b': parseInt($stateParams.id),
        o: 1000,
        'id-q': item.id,
        t: item.t,
        'img-t': item['img-t'],
        cr: item.cr,
        printCount: item.printCount,
        g: false,
      }
      if (this.state.odds.length === 0) {
        OddsService.save(model['id-b'], [model]).then(success.bind(this))

        function success(result) {
          model.id = result.results[0].id
          var odds = this.state.odds
          odds.push(model)
          this.setState({
            odds: odds,
          })
        }
        return
      }
      var odds
      if (this.state.odds.length > 0) {
        odds = this.state.odds
      }

      var len = odds.length
      for (var i = 0; i < len; i++) {
        if (odds[i]['id-q'] !== item.id) {
          OddsService.save(model['id-b'], [model]).then(success.bind(this))

          function success(result) {
            model.id = result.results[0].id
            odds.push(model)
            var check = false
            this.setState({
              odds: odds,
            })

            for (var i = 0; i < this.state.data.length; i++) {
              if (this.state.data[i].tog) {
                check = true
              } else {
                check = false
                break
              }
            }

            // if (check){
            this.setState({
              checkStep2: check,
            })

            this.forceUpdate()
            // }
          }

          return
        }
      }
    },
    remove: function (item, index) {
      var copy
      if (this.state.odds.length > 0) {
        copy = angular.copy(this.state.odds)
      }

      var itemDelete
      var len = copy.length

      for (var i = 0; i < len; i++) {
        if (copy[i]['id-q'] === item.id) {
          itemDelete = copy[i]
          break
        }
      }

      if (itemDelete.id === undefined) {
        return
      }

      OddsService.deleteOdd(itemDelete.id).then(success.bind(this), error.bind(this))

      function success() {
        copy.remove(itemDelete)
        this.setState({
          odds: copy,
          checkStep2: false,
        })

        var check = false
        for (var i = 0; i < copy.length; i++) {
          if (copy[i].tog) {
            check = true
          } else {
            check = false
            break
          }
        }

        this.setState({
          checkStep2: check,
        })
        this.forceUpdate()
      }

      function error(result) {
        swal(result.error.message, '', 'error')
        this.state.data[index].tog = true
        this.setState({
          data: this.state.data,
        })
      }
    },
    removeSoldOut: function () {
      var collectiblesSoldOut = _.filter(angular.copy(this.state.data), { st: 2 })
      var odds = this.state.odds

      var oddsToDelete = []
      for (var i = 0; i < odds.length; i++) {
        for (var j = 0; j < collectiblesSoldOut.length; j++) {
          if (odds[i]['id-q'] === collectiblesSoldOut[j].id) {
            oddsToDelete.push(odds[i].id)
            break
          }
        }
      }

      var promise = []

      for (var x = 0; x < oddsToDelete.length; x++) {
        promise.push(OddsService.deleteOdd(oddsToDelete[x]))
      }

      $q.all(promise).then(success.bind(this), error.bind(this))

      function success() {
        var copy = angular.copy(this.state.data)
        for (var i = 0; i < copy.length; i++) {
          if (copy[i].st === 2) {
            copy[i].tog = false
          }
        }

        this.setState({
          data: copy,
        })
        this.forceUpdate()
        swal('Updated!', '', 'success')
      }

      function error(result) {
        swal(result.error.message, '', 'error')
      }
    },
    render: function () {
      return React.createElement(
        'table',
        { className: 'table' },
        React.createElement(
          'thead',
          null,
          React.createElement(
            'tr',
            { className: 'table-header' },
            React.createElement('th', null, 'Sort'),
            React.createElement('th', null, 'Art'),
            React.createElement('th', null, 'Title'),
            React.createElement('th', null, 'Current Inventory'),
            React.createElement('th', null, 'Print Count'),
            React.createElement('th', null, 'Status'),
            React.createElement(
              'th',
              null,
              'Check All',
              React.createElement('input', {
                type: 'checkbox',
                style: { marginLeft: '10px' },
                checked: this.state.checkStep2,
                onChange: this.toogleAll,
              }),
            ),
          ),
        ),
        React.createElement(
          'tbody',
          null,
          this.state.data.map(function (item, i) {
            var url = this.props.s3 + '/collectibles/' + item['img-t']
            return React.createElement(
              'tr',
              { key: i },
              React.createElement('td', null, React.createElement('label', null, item.n)),
              React.createElement(
                'td',
                null,
                React.createElement('img', {
                  style: { height: '75px', width: '75px' },
                  'data-src': url,
                  className: 'lazyload',
                }),
              ),
              React.createElement('td', null, React.createElement('label', null, item.t)),
              React.createElement('td', null, React.createElement('label', null, item.cr)),
              React.createElement('td', null, React.createElement('label', null, item.printCount)),
              React.createElement('td', null, React.createElement('label', null, item.status)),
              React.createElement(
                'td',
                null,
                React.createElement('input', {
                  type: 'checkbox',
                  checked: item.tog,
                  onChange: this.toogleChange.bind(this, i),
                }),
              ),
            )
          }, this),
        ),
      )
    },
  })
}
